/******************************************************************************
 *
 * Copyright (c) 2019-2022 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Shivam Mishra' <shivam.mishra@wakencode.com>, June 2022
 *
 *****************************************************************************/

import React from "react";
import "./App.css";
import Wrapper from "./container/wrapper";
import Header from "./header/Header";
import "./globalStyle/globalStyle.css";
import Copyright from "./copyright/Copyright";
import { AuthProvider } from "./context/AuthContext";
import { UserProvider } from "./context/UserContext";
import { SALoader } from "./loader/SALoader";

/**
 *  This is the main functional component this render
 *  all the component present in this web-app
 *
 * @returns Header component and the Wrapper container
 */
const App = () => {
  // prevent browser back button
  window.history.pushState(null, null, window.location.href);
  window.onpopstate = function () {
    window.history.go(1);
  };

  return (
    <UserProvider>
      <AuthProvider>
        <div>
          {/* Render the header component */}
          <Header />
          <div className="App">
            {/* Render the wrapper container */}
            <Wrapper />
            {/* Copyright screen */}
            <Copyright />
          </div>
        </div>
      </AuthProvider>
    </UserProvider>
  );
};

export default App;
